<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title>
        <router-link to="pDashboard" class="toolbar-title-link">
          EPhone System
        </router-link>
        <v-menu transition="slide-y-transition">
          <template v-slot:activator="{ props }">
            <v-btn
              color="orange"
              class="text-none bg-primary text-subtitle-1 white--text"
              v-bind="props"
            >
              Hızlı İşlemler
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, i) in items" :key="i">
              <v-list-item-title @click="item.click">{{
                item.title
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          color="white"
          @click="navigateToPhoneSales"
          class="text-none bg-success text-subtitle-1 white--text ml-2"
          v-bind="props"
        >
          Telefonlar
        </v-btn>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click.stop="drawer = !drawer">
        <v-icon class="orange--text">mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-item-group>
          <v-list-item
            v-for="(next, i) in mainMenu"
            :key="i"
            :to="next.href"
            @click.stop
          >
            <v-list-item-icon class="v-list-item-icon">
              <v-icon class="orange--text">{{ next.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="v-list-item-content">
              <v-list-item-title>{{ next.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-container>
      <slot></slot>
    </v-container>

    <v-dialog v-model="transferDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Hızlı Transfer</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="6">
                <v-select
                  v-model="newTransfer.senderSeller"
                  :items="sellerList"
                  label="Gönderici Bayi"
                  item-text="title"
                  item-value="id"
                  :rules="[rules.required]"
                  @input="validateSellers()"
                  required
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="newTransfer.buyerSeller"
                  :items="sellerList"
                  label="Alıcı Bayi"
                  item-text="title"
                  item-value="id"
                  :rules="[rules.required]"
                  @input="validateSellers()"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-col>
              <div
                v-for="(item, index) in newTransfer.transferItems"
                :key="index"
                class="d-flex align-center"
              >
                <v-text-field
                  v-model="newTransfer.transferItems[index].serialNumber"
                  dense
                  label="Seri No"
                  class="mr-2"
                  @input="
                    checkDuplicateSerialNumber(
                      newTransfer.transferItems[index].serialNumber,
                      index
                    )
                  "
                ></v-text-field>
                <span style="position: absolute; font-size: 12px; color: #f00">
                  {{ errorMessages[index] }}
                </span>
                <v-btn
                  icon
                  small
                  dense
                  color="error"
                  style="width: 30px; height: 30px; font-size: 12px"
                  @click="removeTransferItem(index)"
                  v-if="index > 0"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
              <v-btn color="primary" text @click="addTransferItem" class="mt-2">
                <v-icon left>mdi-plus</v-icon>
                Seri No Ekle
              </v-btn>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="makeFastTransfer"
            >Transferi Tamamla</v-btn
          >
          <v-btn color="grey" text @click="fastTrassfer = false">İptal</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fastSale" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Hızlı Satış</span>
        </v-card-title>

        <v-row>
          <v-col cols="12" md="8">
            <!-- Increased size for the input field -->
            <v-text-field
              v-model="serialNumber"
              :label="isSerialNumberValidMessage"
              class="mx-4"
              style="max-width: 100%"
              solo
              dense
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn
              color="orange"
              dark
              class="white--text"
              @click="checkAndNavigate"
            >
              Sorgula
            </v-btn>
          </v-col>
        </v-row>
        <v-card-item> </v-card-item>
        <v-spacer></v-spacer>

        <v-card-text>
          <v-form ref="form" v-model="valid" v-if="isSerialNumberValid">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <CustomerSelect
                    v-model="newSale.selectedCustomer"
                    label="Müşteri Ara"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <div style="display: flex; align-items: center">
                    <v-autocomplete
                      v-model="newSale.selectedPersonal"
                      :items="personals"
                      :loading="loading"
                      item-text="title"
                      item-value="id"
                      label="Personel Ara"
                      solo
                      hide-no-data
                      hide-selected
                      @input="(event) => fetchPersonal(event.target.value)"
                    ></v-autocomplete>

                    <v-btn
                      color="blue"
                      @click="addPersonal"
                      style="margin-left: 8px"
                    >
                      <v-icon>mdi mdi-account-multiple-plus</v-icon>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="newSale.serialNumber"
                    label="Seri No"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="newSale.sellingPrice"
                    label="Satış Fiyatı"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="newSale.cash"
                    label="Kredi Kartı"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="newSale.creditCard"
                    label="Nakit"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="newSale.instalement"
                    label="Taksit"
                    min="0"
                    max="3"
                    type="number"
                    @input="changeInstalement"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="instalementSetting">
                  <v-row>
                    <v-col cols="6">
                      <!-- İlk bileşen için 6 kolon genişliği -->
                      <v-checkbox
                        label="Cariye İşle"
                        v-model="newSale.isCurrent"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <!-- İkinci bileşen için 6 kolon genişliği -->
                      <v-text-field
                        v-model="newSale.OIIUJ9U7INN"
                        label="Ödeme Tarihi"
                        type="date"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newSale.description"
                    label="Açılama"
                    type="text"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions v-if="isSerialNumberValid">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="makeFastSale"
            >Satışı Tamamla</v-btn
          >
          <v-btn color="grey" text @click="fastSale = false">İptal</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions, mapState, useStore } from "vuex";
import { computed } from "vue";
import mainService from "@/services/mainService";
 import Swal from "sweetalert2";
import CustomerSelect from "@/components/CustomerSelect.vue";

export default {
  name: "MainLayout",
  components: {
    CustomerSelect,
  },
  setup() {
    const store = useStore();

    const sellerList = computed(() => store.state.sellerList);

    // fetchSellerList'i çağır
    const fetchSellerList = () => {
      store.dispatch("fetchSellerList");
    };

    // Bileşen oluşturulduğunda satıcı listesini yükle
    fetchSellerList();

    return {
      sellerList,
    };
  },
  data() {
    return {
      isSerialNumberValid: false,
      instalementSetting: false,
      isSerialNumberValidMessage: "Seri No",
      errorMessages: [],
      items: [
        { title: "Transfer Yap", click: () => (this.transferDialog = true) },
        { title: "Hızlı Satış", click: () => (this.fastSale = true) },
        {
          title: "Teknik Servis",
          click: () => this.$router.push("/technicalService"),
        },
        {
          title: "Talepler",
          click: () => this.$router.push("/newProductDemand"),
        },
      ],

      transferDialog: false,
      drawer: false, // Burada drawer değişkeni tanımlanıyor
      fastSale: false,
      customers: [], // Müşteri verileri
      personals: [], // Müşteri verileri

      mainMenu: [
        {
          text: "Ana Sayfa",
          href: "pDashboard",
          icon: "mdi-home",
        },
        {
          text: "Satışlar",
          href: "/sales",
          icon: "mdi-alpha-s-circle",
        },
        {
          text: "Seri Numaraları",
          href: "/serialNumbers",
          icon: "mdi-barcode",
        },
        {
          text: "Transfer İşlemlemleri",
          href: "/transfers",
          icon: "mdi-transfer",
        },
        {
          text: "Talepler",
          href: "/newProductDemand",
          icon: "mdi-cog-sync-outline",
        },
        {
          text: "Stoklar",
          href: "/stocks",
          icon: "mdi-storefront",
        },
        {
          text: "Telefonlar",
          href: "/phones",
          icon: "mdi-phone",
        },
        {
          text: "Kullanıcılar",
          href: "/users",
          icon: "mdi-account",
        },
        {
          text: "Şubeler",
          href: "/sellers",
          icon: "mdi-source-branch",
        },
        {
          text: "Müşteriler",
          href: "/customers",
          icon: "mdi-doctor",
        },
        {
          text: "Markalar",
          href: "/brands",
          icon: "mdi-alpha-b-circle-outline",
        },
        {
          text: "Renkler",
          href: "/colors",
          icon: "mdi-palette",
        },
        {
          text: "Kategoriler",
          href: "/categories",
          icon: "mdi-view-list",
        },

        {
          text: "Fatura İşlemleri",
          href: "/invoices",
          icon: "mdi-receipt",
        },

        {
          text: "Ayarlar",
          href: "/settings",
          icon: "mdi-cog-sync-outline",
        },

        {
          text: "Çıkış",
          href: "/logout",
          icon: "mdi-logout",
        },
      ],
      newSale: {
        serialNumber: "",
        sellingPrice: "",
        selectedCustomer: "",
        selectedPersonal: "",
        cash: "",
        creditCard: "",
        instalement: "",
        descrition: "",
        isCurrent: "",
        padiDate: "",
      },
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
      newTransfer: {
        transferItems: [
          { serialNumber: "" }, // Initial empty item
        ],
        senderSeller: "",
        buyerSeller: "",
      },
    };
  },
  computed: {
    ...mapState(["user"]), // Vuex state'inden user'ı al
  },

  methods: {
    navigateToPhoneSales() {
      this.$router.push("/phoneSales"); // Rota yönlendirmesi
    },
    ...mapActions(["loadUser"]), // Vuex eylemlerini kullan
    checkDuplicateSerialNumber(serialNumber, currentIndex) {
      const duplicateIndex = this.newTransfer.transferItems.findIndex(
        (item, index) =>
          item.serialNumber === serialNumber && index !== currentIndex
      );

      // Hata mesajını temizle
      this.errorMessages[currentIndex] = "";

      if (duplicateIndex !== -1) {
        // Hata mesajını ayarla
        this.errorMessages[currentIndex] = "Aynı Seri Numarası kullanılamaz.";
        // Son girilen alanı sıfırla
        this.newTransfer.transferItems[currentIndex].serialNumber = ""; // Doğrudan atama
      }
    },
   
    checkAndNavigate() {
      this.loading = true;
      // Sayfalama parametrelerini hazırla

      mainService
        .get("stockmovements", this.serialNumber)
        .then((response) => {
          if (response.total == 0) {
            this.isSerialNumberValidMessage =
              "Geri Seri No Giriniz... Ürün Buluanmadı";
          } else {
            this.newSale.serialNumber = response.serial_number;
            this.newSale.sellingPrice = response.selling_price;
            this.isSerialNumberValid = true;
          }
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateSellers() {
      if (this.newTransfer.senderSeller === this.newTransfer.buyerSeller) {
        Swal.fire({
          title: "Hata!",
          text: "Gönderici ve Alıcı bayi aynı olamaz.",
          icon: "error",
          confirmButtonText: "Tamam",
          confirmButtonColor: "#ff9800",
        });
        this.transferDialog = false; // Modalı kapat
        this.newTransfer.buyerSeller = ""; // veya senderSeller
      }
    },

    async makeFastSale() {
      if (this.$refs.form.validate()) {
        this.validateSellers();
        try {
          await mainService.add(this.newSale, "sale"); // Yeni stokyı ekle
          (this.isSerialNumberValid = false),
            (this.isSerialNumberValidMessage = "Seri No"),
            (this.fastSale = false);
          this.resetNewSale(); // Yeni stok formunu sıfırla
        } catch (error) {
          console.error("Satışta hata oluştu:", error);
        }
      }
    },
    async makeFastTransfer() {
      if (this.$refs.form.validate()) {
        this.validateSellers();
        try {
          await mainService.add(this.newTransfer, "transfer"); // Yeni stokyı ekle
          this.transferDialog = false; // Modalı kapat
          this.resetNewTransfer(); // Yeni stok formunu sıfırla
        } catch (error) {
          console.error("Stok eklenirken hata oluştu:", error);
        }
      }
    },

 

    addTransferItem() {
      this.newTransfer.transferItems.push({ serialNumber: "" });
    },

    removeTransferItem(index) {
      this.transferItems.splice(index, 1);
    },

    changeInstalement() {
      if (this.newSale.instalement > 0) {
        this.instalementSetting = true; // instalementSetting'i true yap
      } else {
        this.instalementSetting = false; // Eğer 0 veya daha düşükse false yapabilirsiniz
      }
    },

    resetNewSale() {
      this.newSale = {
        serialNumber: "",
        sellingPrice: "",
        selectedCustomer: "",
        selectedPersonal: "",
        cash: "",
        creditCard: "",
        instalement: "",
        descrition: "",
      };
    },
    resetNewTransfer() {
      this.newTransfer = {
        senderSeller: "",
        buyerSeller: "",
        transferItems: [
          { serialNumber: "" }, // Initial empty item
        ],
      };
    },
  },
  async created() {
    await this.loadUser(); // Kullanıcı verisini yükle
  },
};
</script>

<style scoped>
.toolbar-title-link {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.toolbar-title-link:hover {
  opacity: 0.8;
}
</style>
